import { RouteObject } from "react-router-dom";
import List from "../../Pages/Setting/Concentration/List";
import AddUpdate from "../../Pages/Setting/Concentration/AddUpdate";
import AuthorizedRoute from "../../Util/AuthorizedRoute";
import {
  ADD_CONCENTRATION,
  DELETE_CONCENTRATION,
  RESTORE_CONCENTRATION,
  UPDATE_CONCENTRATION,
  VIEW_CONCENTRATION,
} from "../../Util/PermissionList";

export const CONCENTRATION_TITLE = "Concentration";
export const CONCENTRATION_LIST = "/concentration";
export const CONCENTRATION_ADD = "/concentration/add";
export const CONCENTRATION_EDIT = "/concentration/:id/edit";
export const CONCENTRATION_ARCHIVE = "/concentration/archive";

const Concentration: RouteObject[] = [
  {
    path: CONCENTRATION_LIST,
    element: (
      <AuthorizedRoute
        permission={VIEW_CONCENTRATION}
        checkPermisson={{
          addPermission: ADD_CONCENTRATION,
          updatePermission: UPDATE_CONCENTRATION,
          deletePermission: DELETE_CONCENTRATION,
          restorePermission: RESTORE_CONCENTRATION,
          viewPermission: VIEW_CONCENTRATION,
        }}
        element={<List />}
      />
    ),
  },
  {
    path: CONCENTRATION_ADD,
    element: (
      <AuthorizedRoute
        element={
          <AddUpdate
            title={CONCENTRATION_TITLE}
            listRoute={CONCENTRATION_LIST}
          />
        }
        permission={ADD_CONCENTRATION}
        checkPermisson={{
          addPermission: ADD_CONCENTRATION,
          updatePermission: UPDATE_CONCENTRATION,
          deletePermission: DELETE_CONCENTRATION,
          restorePermission: RESTORE_CONCENTRATION,
          viewPermission: VIEW_CONCENTRATION,
        }}
      />
    ),
  },
  {
    path: CONCENTRATION_EDIT,
    element: (
      <AuthorizedRoute
        element={
          <AddUpdate
            title={CONCENTRATION_TITLE}
            listRoute={CONCENTRATION_LIST}
          />
        }
        permission={UPDATE_CONCENTRATION}
        checkPermisson={{
          addPermission: ADD_CONCENTRATION,
          updatePermission: UPDATE_CONCENTRATION,
          deletePermission: DELETE_CONCENTRATION,
          restorePermission: RESTORE_CONCENTRATION,
          viewPermission: VIEW_CONCENTRATION,
        }}
      />
    ),
  },
  {
    path: CONCENTRATION_ARCHIVE,
    element: (
      <AuthorizedRoute
        element={<List />}
        checkPermisson={{
          addPermission: ADD_CONCENTRATION,
          updatePermission: UPDATE_CONCENTRATION,
          deletePermission: DELETE_CONCENTRATION,
          restorePermission: RESTORE_CONCENTRATION,
          viewPermission: VIEW_CONCENTRATION,
        }}
        permission={DELETE_CONCENTRATION}
      />
    ),
  },
];

export default Concentration;
